import numeral from 'numeral'

export const formatCurrency = (number) => {
  return numeral(number).format('0,0').replace(/,/g,' ')
}

export const formatPercent = (number) => {
  return numeral(number).format('0.00').replace(/\./g,',')
}
